export default "__VITE_ASSET__Db4BMZWw__"